import { render, staticRenderFns } from "./changePassForm.vue?vue&type=template&id=5e15f11b&scoped=true&"
import script from "./changePassForm.vue?vue&type=script&lang=ts&"
export * from "./changePassForm.vue?vue&type=script&lang=ts&"
import style0 from "./changePassForm.vue?vue&type=style&index=0&id=5e15f11b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e15f11b",
  null
  
)

export default component.exports